define(['exports', 'lodash', 'react', 'prop-types', 'react-select', './styles/SelectField.css'], function (exports, _lodash, _react, _propTypes, _reactSelect) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _lodash2 = _interopRequireDefault(_lodash);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactSelect2 = _interopRequireDefault(_reactSelect);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SelectField = function (_Component) {
    _inherits(SelectField, _Component);

    function SelectField() {
      _classCallCheck(this, SelectField);

      return _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).apply(this, arguments));
    }

    _createClass(SelectField, [{
      key: 'renderErrorText',
      value: function renderErrorText() {
        return !_lodash2.default.isEmpty(this.props.errorText) ? _react2.default.createElement(
          'div',
          { className: 'h6 red' },
          this.props.errorText
        ) : _react2.default.createElement('div', null);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_reactSelect2.default, this.props),
          this.renderErrorText()
        );
      }
    }]);

    return SelectField;
  }(_react.Component);

  exports.default = SelectField;


  SelectField.propTypes = {
    defaultValue: _propTypes2.default.any,
    hintText: _propTypes2.default.any,
    style: _propTypes2.default.any,
    onChange: _propTypes2.default.func
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/SelectField.js
// module id = 1155
// module chunks = 0